<template>
  <div>
    <v-dialog max-width="500px" v-model="dialog">
      <template v-slot:activator="{ on }">
        <v-btn outlined small v-on="on" color="red darken-4">
          <v-icon small>add</v-icon>
          {{ btnLabel }}</v-btn
        >
      </template>

      <v-card>
        <h1 class="subtitle-2 text-center">
          {{ title }}
        </h1>

        <v-card-text>
          <v-file-input
            v-if="!uploadCompleted"
            :disabled="uploading"
            v-model="file"
            :accept="accept"
            label="Seleccione un archivo..."
          />

          <v-progress-circular
            v-if="uploading"
            :rotate="-90"
            :size="100"
            :width="15"
            :value="percentCompleted"
            color="primary"
            >{{ percentCompleted }}</v-progress-circular
          >

          <div v-if="uploadCompleted">
            <v-icon large class="green--text">check_circle_outline</v-icon>
            <div>Listo!</div>
          </div>
          <h1>{{ errorMessage }}</h1>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="red"
            @click="volver"
            :disabled="uploading || (!uploadCompleted && uploading)"
            >Volver</v-btn
          >
          <v-spacer v-if="!uploadCompleted"></v-spacer>
          <v-btn
            outlined
            small
            color="red"
            @click="adjuntar"
            :disabled="!file || uploading"
            v-if="!uploadCompleted"
            >Adjuntar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="5000">
      Archivo adjuntado!
      <v-btn color="blue" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["btnLabel", "accept", "title"],
  data() {
    return {
      errorMessage: "",
      dialog: false,
      snackbar: false,
      uploading: false,
      uploadCompleted: false,
      fileId: null,
      file: null,
      percentCompleted: 0
    };
  },
  methods: {
    adjuntar() {
      //this.snackbar = true;

      if (this.file.size == 0) {
        this.errorMessage = "Archivo no valido!";
        return;
      }

      this.uploading = true;
      const config = {
        onUploadProgress: function(progressEvent) {
          this.percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }.bind(this)
      };

      let data = new FormData();
      data.append("file", this.file);

      axios
        .post("/miapa/upload", data, config)
        .then(res => {
          this.uploading = false;
          this.uploadCompleted = true;
          console.log(res);
          //this.dialog = false;
          //this.$store.dispatch("showSnack", "Archivo adjuntado con exito!");
          this.fileId = res.data;
        })
        .catch(err => {
          console.log(err);
          this.uploading = false;
          this.uploadCompleted = false;
        });
    },
    volver() {
      // axios
      //   .get("/upload/files")
      //   .then(res => console.log(res))
      //   .catch(err => console.log(err));
      if (this.uploadCompleted) {
        this.$emit("save", this.fileId);
      }
      this.dialog = false;
      this.file = null;
      this.fileId = null;
      this.uploading = false;
      this.uploadCompleted = false;
    }
  }
};
</script>
